import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.GET_TEMPLATES](state) {
    return state.templates;
  },
};
